type FoilOptionConstant = {
  optionId: string;
  value: string;
  assetThumbnailUrl: string;
};

export const FOIL_ATTRIBUTE_OPTIONS: readonly FoilOptionConstant[] = [
  { optionId: 'gold', value: 'GOLD', assetThumbnailUrl: 'https://withjoy.com/media/print/foil_color_gold.jpeg' },
  { optionId: 'roseGold', value: 'ROSEGOLD', assetThumbnailUrl: 'https://withjoy.com/media/print/foil_color_rosegold.jpeg' },
  { optionId: 'silver', value: 'SILVER', assetThumbnailUrl: 'https://withjoy.com/media/print/foil_color_silver.jpeg' },
];
